import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult, useQueryClient, UseQueryResult } from '@tanstack/react-query'
import { usePortalMutation } from 'src/Libs/api'
import { InstallationConfigDto, InstallationConfigPUTDto, updateInstallationConfig } from 'src/Libs/flow/installation/api'
import { installationConfigKey, useInstallationConfig } from 'src/Libs/flow/installation/hooks'

type ChargingStrategyPayload = Pick<InstallationConfigPUTDto, 'emsBatteryBeforeCarMode' | 'emsWeatherRegulatedChargeEnabled'>

interface UseChargingStrategyResult {
  query: UseQueryResult<Nullable<InstallationConfigDto>, Error>
  mutation: UseMutationResult<null, Error, ChargingStrategyPayload>
}

export const useChargingStrategy = (installationId: number | undefined): UseChargingStrategyResult => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  const query = useInstallationConfig(installationId)

  const mutation = usePortalMutation({
    mutationFn: (payload: ChargingStrategyPayload) => {
      if (!installationId) throw new Error('missing-installation-id')
      return updateInstallationConfig(installationId, payload, authFetch)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: installationConfigKey(installationId) })
    },
  })

  return { query, mutation }
}
